<div data-target="pageNotFound" cdkTrapFocus [attr.aria-modal]="true">
  <article class="dt-l-article">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img [attr.alt]="'UI_COMPANY_LOGO' | translate" src="assets/img/logo-default.png" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'SOMETHING_WENT_WRONG' | translate }}
        </h1>
        <p class="dt-l-article__section__description">
          {{ 'SOMETHING_WENT_WRONG_TEXT' | translate }}
        </p>
        <div class="dt-l-button-group__vertical">
          <button type="button" class="dt-c-button primary orderButtonVertical" [routerLink]="route">
            {{ 'BACK_TO_HOMESCREEN' | translate }}
          </button>
        </div>
      </section>
    </div>
  </article>
</div>
